
import fondo from '../assets/fondo4.png'

import CountUp from 'react-countup';

const stats = [
  { value: 1160, label: 'Niños apoyados' },
  { value: 34, label: 'Voluntarios y Personal de apoyo' },
  { value: 1160, label: 'Revisiones médicas realizadas' },
  { value: 100, label: 'Capacitacion de jovenes' },
  { value: 5, label: 'Patrocinadores activos' },
  { value: 1148, label: 'Familias apoyadas con canastas nutritivas' },
];


const EmpresasRamos = () => {
   
    
      return (
    
        <div name="impacto" className="bg-gradient-to-b from-gray-800 to-green-one w-full h-fit pt-10"
        style={{
                backgroundImage: `url(${fondo})`,
              }}>
          <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-green-two">
    
            <div>
              <p className="text-4xl font-bold border-b-4 border-orange-one p-2 inline font-montserrat">Impacto 2025</p>
              <p className="py-6 font-montserrat">Conoce los logros que se han desarrollado en el año 2025</p>
            </div>
    
          
            <div className="bg-gray-100 py-10 px-4">
                  <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-center">
                    {stats.map((stat, idx) => (
                      <div key={idx} className="flex flex-col items-center justify-center">
                        <h2 className="text-4xl sm:text-5xl font-bold text-black">
                          <CountUp end={stat.value} duration={2} suffix={stat.suffix || ''} />
                        </h2>
                        <p className="mt-2 text-base sm:text-lg text-orange-one">{stat.label}</p>
                      </div>
                    ))}
                  </div>
                </div>
          </div>
        </div>
      )
}

export default EmpresasRamos